import { useTranslation } from '@packlink/translation-provider';
import { useMemo } from 'react';

export function useGetEmailTags() {
    const { t } = useTranslation();

    const availableTags = useMemo(() => {
        const tags = [
            {
                key: 'order_source',
                translation: t('branded-emails.tag.order_source'),
                description: t('branded-emails.tag.order_source_description'),
            },
            {
                key: 'order_id',
                translation: t('branded-emails.tag.order_id'),
                description: t('branded-emails.tag.order_id_description'),
            },
            {
                key: 'receiver_name',
                translation: t('branded-emails.tag.receiver_name'),
                description: t('branded-emails.tag.receiver_name_description'),
            },
            {
                key: 'content',
                translation: t('branded-emails.tag.content'),
                description: t('branded-emails.tag.content_description'),
            },
            {
                key: 'trackings',
                translation: t('branded-emails.tag.trackings'),
                description: t('branded-emails.tag.trackings_description'),
            },
            {
                key: 'tracking_id',
                translation: t('branded-emails.tag.tracking_id'),
                description: t('branded-emails.tag.tracking_id_description'),
            },
            {
                key: 'estimated_delivery_date',
                translation: t('branded-emails.tag.estimated_delivery_date'),
                description: t('branded-emails.tag.estimated_delivery_date_description'),
            },
            {
                key: 'company_name',
                translation: t('branded-emails.tag.company_name'),
                description: t('branded-emails.tag.company_name_description'),
            },
            {
                key: 'sender_email',
                translation: t('branded-emails.tag.sender_email'),
                description: t('branded-emails.tag.sender_email_description'),
            },
            {
                key: 'carrier_name',
                translation: t('branded-emails.tag.carrier_name'),
                description: t('branded-emails.tag.carrier_name_description'),
            },
            {
                key: 'service_name',
                translation: t('branded-emails.tag.service_name'),
                description: t('branded-emails.tag.service_name_description'),
            },
        ];

        return tags.sort((a, b) => a.translation.localeCompare(b.translation));
    }, [t]);

    return availableTags;
}
